import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { IonApp, IonRouterOutlet, isPlatform } from '@ionic/vue';
import { StatusBar, Style } from '@capacitor/status-bar';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

onMounted(() => {
  if (isPlatform('capacitor')) {
    try {
      const setStatusBarStyleDark = async () => {
        await StatusBar.setStyle({ style: Style.Light });
      };
      setStatusBarStyleDark();
    } catch (e) {
      //
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_unref(IonRouterOutlet), {
        key: _unref(router).currentRoute
      }))
    ]),
    _: 1
  }))
}
}

})